<script setup lang="ts">
export type BadgeVariant = 'success' | 'warning' | 'danger' | 'info' | 'neutral' | 'gold'

interface Props {
  variant?: BadgeVariant
}

withDefaults(defineProps<Props>(), {
  variant: 'neutral'
})
</script>

<template>
  <span :class="['badge', `badge-${variant}`]">
    <slot />
  </span>
</template>
